import clientLogo from "../../images/clients/Colored/Ecozohm.jpg"

const ecoZohm = {
  pageTitle: "Visiomate - EcoZohm Case Study",
  metaDescription:
    "Visiomate implemented Odoo for EcoZohm in seven weeks, with a custom quotation portal, shipping automation and raw material tracking.",
  clientName: "EcoZohm",
  bannerSummary: "Odoo ERP for a sustainable LED lighting manufacturer, live in seven weeks",
  introHeading: "Streamlined Odoo ERP Implementation for EcoZohm",
  heroImageAlt: "Warehouse shelving",
  clientLogoSrc: clientLogo,
  about:
    "EcoZohm is a leader in sustainable energy technology, specialising in advanced LED lighting for industrial, commercial and agricultural sectors. Its mission is to speed the move to environmentally conscious energy products with high-efficiency fixtures that cut maintenance costs and carbon footprints.",

  challengesIntro: "Complex products, around 500 SKUs and many hand-offs were being managed manually.",
  challenges: [
    {
      title: "Fragmented Management",
      desc: "Vendor shipments and about 500 SKUs were tracked by hand.",
    },
    {
      title: "Manual Quoting",
      desc: "Quotes with variables such as mounting height, voltage and temperature took too long to produce.",
    },
    {
      title: "Communication Silos",
      desc: "Sales orders, customer POs and vendor fulfilment weren't synchronised.",
    },
    {
      title: "Inventory Blind Spots",
      desc: "Raw material use for specialised crane product lines couldn't be tracked accurately.",
    },
  ],

  solutionsIntro: "One Odoo system now carries a quote through to payment.",
  solutions: [
    {
      num: "01",
      text: "Custom Quotation Portal",
      desc: "An intake form captures a project's environmental specifications and produces the quote instantly.",
    },
    {
      num: "02",
      text: "End-to-End Automation",
      desc: "Packing lists, UPS, DHL and USPS shipping labels, and vendor part number sync run automatically.",
    },
    {
      num: "03",
      text: "Custom Raw Material Module",
      desc: "A dedicated module tracks inventory consumption for specialised industrial products.",
    },
    {
      num: "04",
      text: "Financial Intelligence",
      desc: "Automated invoice verification and payment tracking give full financial visibility.",
    },
  ],

  resultsIntro: "EcoZohm went from scope to a live, automated system in seven weeks.",
  metrics: [
    { metric: "7 weeks", label: "From initial scope to live deployment" },
    { metric: "99%", label: "Quote accuracy through automation, with dealer and customer prices generated from pre-set margins" },
    { metric: "100%", label: "Of manual entry of tracking numbers and expected shipping dates eliminated" },
  ],
  outcomes: [
    "Quotes for complex projects come from one intake form, in seconds",
    "Shipping details flow into the system without anyone typing them",
    "Management sees raw material use and payments in one place",
  ],

  relatedLinks: [
    {
      to: "/caseStudies/projects/cakesAndBakes",
      label: "Read the Cakes & Bakes story",
      note: "Dynamics 365 re-implemented for a bakery production facility.",
    },
    {
      to: "/caseStudies/projects/borjan",
      label: "See Borjan's reporting story",
      note: "25+ supply chain and finance reports built on Dynamics 365.",
    },
  ],
}

export default ecoZohm
